import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AthletesProvider } from "../providers/athletes-provider";
import { inject } from "@angular/core";
import { EMPTY, Observable, switchMap, throwError } from "rxjs";
import { OrganizationsProvider } from "../../organizations/providers/organizations-provider";
import { catchError, map } from "rxjs/operators";
import { Organization } from "../../common/models/organization";
import { User } from "../../common/models/user";

export function AthleteResolver(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<User> {
  const router = inject(Router);  // Inject the Router

  const athletesProvider = inject(AthletesProvider);
  const organizationsProvider = inject(OrganizationsProvider);
  const code = route.paramMap.get('organizationCode');
  if (!code) throw new Error('Organization code is required');
  return organizationsProvider.getByCode(code).pipe(
    switchMap((organization: Organization) => {
      return athletesProvider.get(organization.id!, +route.params['athleteId']);
    }),
    catchError((error) => {
      if (error.status === 404) {
        // redirect to dashboard
        router.navigate([`/${route.params['organizationCode']}`]);
        return EMPTY; // Return an empty observable to stop the flow
      }
      console.error("AthleteResolver : ", error);
      return throwError(() => new Error('Failed to retrieve athlete data'));
    }),
  );
}
